import { gql } from "@apollo/client";

export const TASK_SHOTS_QUERY = gql`
  query TaskShotsQuery($taskShotIds: [SmartID!]!) {
    taskShots(taskShotIds: $taskShotIds) {
      __typename
      id
      shot {
        __typename
        id
        name
        frameCount
        frameKeys
        defaultReferenceFrameKeys
        created
        videoStorageKey
        serviceIds
      }
    }
  }
`;

export const CREATE_SUB_TASK_MUTATION = gql`
  mutation CreateSubTaskMutation(
    $taskShotIds: [SmartID!]!
    $projectId: SmartID!
    $vendorIds: [SmartID!]!
    $serviceId: SmartID!
    $currency: Currency!
    $deadline: DateTime!
    $deliverables: [TaskDeliverableInput]!
    $taskDetails: [TaskDetailsInput]
    $fileAttachmentIds: [SmartID!]
  ) {
    createSubTask(
      taskShotIds: $taskShotIds
      projectId: $projectId
      vendorIds: $vendorIds
      serviceId: $serviceId
      currency: $currency
      deadline: $deadline
      deliverables: $deliverables
      taskDetails: $taskDetails
      referenceAttachmentIds: $fileAttachmentIds
    ) {
      success
      message
      task {
        id
      }
    }
  }
`;
